import { css } from "@emotion/react";

import { colors } from "@styles";

export const brandName = css`
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${colors.grey.base};
`;

export const noClip = css`
  white-space: normal;
`;
